// extracted by mini-css-extract-plugin
module.exports = {"square":"hero_square__v5HRL","title":"hero_title__aH5v7","pitch":"hero_pitch__yJu_D"};